var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _rect4, _path8, _polygon, _path9, _polygon2, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThoughts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 926.012,
    height: 493,
    "data-name": "Layer 1",
    viewBox: "0 0 926.012 493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M506.00591,203.5v250h557v-250Zm2,248v-246h137v246Zm139-246h158v246h-158Zm414,246h-254v-246h254Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b1fa2",
    d: "M569.38155,325.74329h-37.8935c4.26233-17.48727,8.35688-33.81351,0-45.47221h37.8935Q580.08,303.031,569.38155,325.74329Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M759.88631,411.19166H721.99275c-2.37-21.07947,2.859-36.79132,0-45.4722h37.89356A237.22594,237.22594,0,0,0,759.88631,411.19166Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b1fa2",
    d: "M713.58785,344.95316H675.69429c1.42084-17.48447,6.002-33.81122,0-45.47221h37.8935Q724.28957,322.217,713.58785,344.95316Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6584",
    d: "M746.32338,315.21757h37.8935c2.36987-17.48761-2.859-33.81382,0-45.47222h-37.8935Q735.62169,292.48145,746.32338,315.21757Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M570.53951,397.21445H608.433c2.36987-17.48761-2.859-33.81381,0-45.4722H570.53951Q559.83773,374.47832,570.53951,397.21445Z",
    transform: "translate(-136.99409 -203.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.896,
    height: 2,
    x: 406.115,
    y: 21.457,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55.896,
    height: 2,
    x: 560.115,
    y: 21.457,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 55.896,
    height: 2,
    x: 769.115,
    y: 21.457,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M195.90755,548.99181v2.73636a17.11717,17.11717,0,0,0,17.10229,17.1023H358.03729a17.1086,17.1086,0,0,0,17.10229-17.1023v-2.73636a16.97953,16.97953,0,0,0-3.96827-10.94547,17.59387,17.59387,0,0,0-2.88668-2.73637h-75.2227a3.42181,3.42181,0,0,1-3.42046-3.42046H213.00984A17.126,17.126,0,0,0,195.90755,548.99181Z",
    transform: "translate(-136.99409 -203.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 17.786,
    height: 125.873,
    x: 275.953,
    y: 568.151,
    fill: "#ccc",
    transform: "translate(432.69796 1058.67496) rotate(-180)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M225.33005,693.39908c0,1.92179,26.95249.74334,60.20007.74334s60.20007,1.17845,60.20007-.74334-26.95249-17.16155-60.20007-17.16155S225.33005,691.47729,225.33005,693.39908Z",
    transform: "translate(-136.99409 -203.5)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#a0616a",
    points: "239.093 474.5 256.084 474.499 264.167 408.962 239.09 408.963 239.093 474.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M371.753,672.45235l33.46139-.00135h.00136A21.32537,21.32537,0,0,1,426.54,693.77488v.69295l-54.78594.002Z",
    transform: "translate(-136.99409 -203.5)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#a0616a",
    points: "173.322 439.693 159.556 449.653 114.588 401.297 134.905 386.597 173.322 439.693"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M323.48168,653.996l-44.3858,32.11541-.40623-.56139a21.32536,21.32536,0,0,1,4.77507-29.77631l.0011-.0008,27.1094-19.61491Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M328.91234,388.43837s-17.82665-13.35247-37.10187,0L278.46968,499.70894h40.05741l5.93443-35.60658L337.814,410.69249Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M369.04271,560.28735,297.15022,536.812l-34.27275,27.19677,36.409,55.66172-19.043,24.97447-.54469-.62024c-2.36251-2.69077-57.86093-66.11339-57.70026-84.1016.15935-17.83778,6.06942-35.76925,6.12914-35.94872L246.15579,498.385l25.58712-7.52467,84.7103,11.88877.13823.01979L390.81735,523.601a26.88759,26.88759,0,0,1,12.20483,19.79878c1.46976,13.22822,4.42513,119.16087,4.45482,120.2298l.01947.69413H370.529Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M323.44534,533.70818c-12.49515-5.55311-28.45275-27.23635-31.08282-30.89312-5.14138,2.799-42.63607,22.83795-53.20618,17.686-1.53542.84721-8.47515,4.98829-9.7252,11.23686l-.31341,1.56775-.90595-1.317c-.16693-.24281-16.4518-24.45716,4.61517-39.50651,19.20889-13.71979,24.37666-27.58078,24.918-29.167l-10.42263-55.089.27349-.254c.85481-.79378,21.14483-19.46228,39.65827-21.68259l11.4203-2.01314.49949,43.47735V483.4135C308.4016,482.25352,323,385,323,385l7.62855,2.79526c1.97123.37808,24.123,4.80289,30.00169,13.62082l.191.28636-20.14816,54.474-5.89259,8.872v11.35629l34.42485,29.935-.48893.512c-1.17317,1.22859-26.55773,27.63093-41.34512,27.627A9.58693,9.58693,0,0,1,323.44534,533.70818Z",
    transform: "translate(-136.99409 -203.5)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310.323,
    cy: 339.975,
    r: 33.19,
    fill: "#a0616a",
    transform: "translate(-273.83342 245.69729) rotate(-61.3368)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M301.96628,543.59261A12.99561,12.99561,0,0,1,318.725,532.81127l19.02331-22.80433,16.67768,8.18044L327.10914,550.0142a13.066,13.066,0,0,1-25.14286-6.42159Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M315.41194,524.25417l29.844-40.28906-7.39237-39.91824,11.993-44.97318.30187-.12932c.24183-.10426,5.982-2.52252,10.351-.71a6.99607,6.99607,0,0,1,3.895,4.04738c2.96922,7.42306,10.12736,83.02147,10.43022,86.3668-.061.611-1.53047,15.02955-4.51883,21.00626-2.9745,5.949-30.10562,35.96588-31.259,37.242l-.47672.52655Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M338.83417,331.43286c-11.048,13.89481-29.98328,11.34865-45.13384,6.26408a48.012,48.012,0,0,1-8.54218,31.34441c1.95651-7.88143-6.2857-9.4499-11.09523-12.38081-1.85168-2.3439-.31336-5.84226-1.07334-8.73065-8.63592-10.12514-14.35845-17.764-3.273-29.64551,6.48921-8.68649,14.278-19.53192,26.64187-17.25022,9.78314-11.41265,25.81532-8.44451,36.75418-.46129a78.14192,78.14192,0,0,1,13.3285,12.52493,53.05291,53.05291,0,0,1-6.92337,17.391",
    transform: "translate(-136.99409 -203.5)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M518.99409,696.5h-381a1,1,0,0,1,0-2h381a1,1,0,1,1,0,2Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#7b1fa2",
    d: "M330.00947,561.87784H292.11591c1.42084-17.48447,6.002-33.81122,0-45.47221h37.8935Q340.71119,539.14172,330.00947,561.87784Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0616a",
    d: "M313.45255,553.294a12.99555,12.99555,0,0,0-16.75876-10.78134l-19.0233-22.80433-16.67769,8.18044,27.3169,31.82681a13.066,13.066,0,0,0,25.14285-6.42158Z",
    transform: "translate(-136.99409 -203.5)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M276.58076,549.20885c-1.70136-1.27611-41.7199-31.355-46.19089-40.29566-4.47759-8.9565-3.36776-35.47695-3.30969-36.68311.06961-.417,7.03673-41.86275,12.93-56.59538,6.11462-15.28622,21.49454-9.34052,21.64927-9.27849l.46484.18607-6.69691,78.13083,36.5287,48.45706-14.88241,16.44818Z",
    transform: "translate(-136.99409 -203.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughts);
export default __webpack_public_path__ + "static/media/thoughts.6d434ce1a97e9cda875407c76d5ef169.svg";
export { ForwardRef as ReactComponent };